export default defineAppConfig({
  ui: {
    button: {
      variant: {
        main: "gradient-border",
        full: "gradient-wrapper",
      },
    },
    primary: "woodsmoke",
    gray: "woodsmoke",
    tooltip: {
      default: {
        openDelay: 500,
      },
    },
  },
});
